import { render, staticRenderFns } from "./Pictures.vue?vue&type=template&id=88897a08&scoped=true"
import script from "./Pictures.vue?vue&type=script&lang=ts"
export * from "./Pictures.vue?vue&type=script&lang=ts"
import style0 from "./Pictures.vue?vue&type=style&index=0&id=88897a08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88897a08",
  null
  
)

export default component.exports